import styled from "styled-components"

export const PermissionsSummaryWrapper = styled.div`
	padding-top: 24px;
	margin-top: 4px;
	border-top: 1px solid #eaeafd;
	.header {
		margin-bottom: 8px;
		p {
			margin: 0;
			padding: 0;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0%;
			color: #130080;
		}
	}
	.viewList {
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		.containerHeader {
			border-bottom: 1px solid #e2e8f0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 13px 16px;
			color: #435363;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0%;
		}
		.containerList {
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #e2e8f0;
			padding: 16px;
			color: #435363;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0%;
			&:last-child {
				border-bottom: none;
			}
			.Close {
				color: #ef4444;
				font-size: 16px;
			}
			.Checkmark {
				color: #22c55e;
				font-size: 16px;
			}
		}
	}
`
